import { combineEpics } from 'redux-observable';
// ---- external imports ------

import hintsEpic from './hints/epic';
import levelEpic from './level/epic';
import financialStatementsEpic from './financial-statements/epic/epic';
import prepareCustomerEpic  from './customers/epic';
import turnEpic from './turn/epic';
import uiEpic from './ui/epic';
import logbookEpic from './logbook/epic';
import loadingEpic from './loading/epic';
import employeesEpic from './employees/epic/epic';
// ---- local imports ------

export default combineEpics(
	hintsEpic,
	levelEpic,
	financialStatementsEpic,
	prepareCustomerEpic,
	turnEpic,
	uiEpic,
	logbookEpic,
	loadingEpic,
	employeesEpic,
);
